/* eslint-disable react-hooks/exhaustive-deps */
import Grid from '@mui/material/Grid';
import React from 'react';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import counselorServices from 'services/counselorServices';
import RAdditionalInfo from 'screen/counselor/components/RAdditionalInfo';
import './sumary.scss';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

const ReviewAdditionalInfo = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();  
  let studentId = getUserId();
  let token = getAccessToken();
  const [listCounselorConnection, setListCounselorConnection] = React.useState<any[]>([]);
  const [currentModuleId, setCurrentModuleId] = React.useState('7.1');

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };  

  const getData = () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      counselorServices.getCounselors(studentId).then((res: any[]) => {
        setListCounselorConnection(res ?? []);
      });      
    }
    else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getData();
    console.log('listCounselorConnection', listCounselorConnection);
    console.log('currentModuleId', currentModuleId);
  }, []);

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid item xs={12} md={8}>
        <RAdditionalInfo setCurrentModuleId={setCurrentModuleId} />
      </Grid>
      {/* <Grid item xs={12} md={4} sx={{ marginTop: { md: '48px' } }}>
        {listCounselorConnection.map((item, index) => (
          <ConversationCard conversationItem={item} currentModuleId={currentModuleId} key={index} />
        ))}
      </Grid> */}
    </Grid>
  );
};

export default ReviewAdditionalInfo;
